import { Layout } from 'utils/router/components/Layout/Layout'

export const WebViewRoutes = [
  {
    path: 'webview/:flow_ns',
    Component: Layout,
    alias: 'webviewFlowBuilder',
    children: [
      {
        index: true,
        lazy: () => import('./flowMobileWebView.page'),
      },
    ],
  },
  {
    path: 'webview-page',
    Component: Layout,
    children: [
      {
        path: 'questionnaire',
        alias: 'webViewQuestionnaire',
        query: ['allowClose', 'selectedChannel'],
        lazy: () => import('./questionnaire.page'),
      },
      {
        path: 'easy-builder/:flow_id?',
        alias: 'webviewEasyBuilder',
        query: ['folder_id', 'campaign_type', 'options', 'source'],
        lazy: () => import('./easyBuilderWebView.page'),
      },
    ],
  },
  {
    path: 'webview-page',
    Component: Layout,
    children: [
      {
        path: 'billing',
        alias: 'billingWebView',
        index: true,
        lazy: () => import('./billingWebView.page'),
      },
    ],
  },
] as const
